<template>
  <div class="card--locations">
    <v-row no-gutters>
      <v-col cols="3">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
           <span class="text--subtitle overflow--hidden" v-on="on">{{ location.ref }}</span>
          </template>
           <span class="text--normal">{{ location.ref }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="4">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
           <span class="text--normal overflow--hidden" v-on="on">{{ location.address | AddressObjectToString([['street', 'streetNo'], 'postalCode', ['city', 'countryCode']]) }}</span>
          </template>
           <span class="text--normal">{{ location.address | AddressObjectToString([['street', 'streetNo'], 'postalCode', ['city', 'countryCode']]) }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2">
        <span class="text--normal">{{ $t('locations.' + location.type) }}</span>
      </v-col>
      <v-col cols="3">
        <v-row justify="end">
          <span
            v-for="(requiremnt, index) in location.requiremnts"
            :key="'requiremnt' + index"
            class="card--label label-pink">{{requiremnt}}</span>
          <span
            v-for="(accessory, index) in location.accessories"
            :key="'accessory' + index"
            class="card--label label-yellow">{{accessory}}</span>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'LocationsOverviewCard',
  props: {
    location: Object
  }
}
</script>

<style lang="scss" scoped>
  .card--locations {
    .text--normal {
      font-size: 14px;
      color: #484848;
      font-weight: 500;
      &.overflow--hidden {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 95%;
        display: block;
      }
    }
    .text--subtitle {
      font-size: 14px;
      color: #767676;
      font-weight: 500;
      &.overflow--hidden {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 95%;
        display: block;
      }
    }
    .text--small {
      font-size: 13px;
      color: #767676;
      text-align: left;
    }
    .card--label {
      font-size: 13px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      padding: 2px 8px;
      border-radius: 20px;
      margin-right: 5px;
      margin-bottom: 1px;
      background-color: #767676;
      &.label-yellow {
        background-color: #FFB900;
      }
      &.label-pink {
        background-color: #ef476f;
      }
    }
  }
</style>
